/* global window */

import { RouteHandler } from 'wee-routes';
import $events from 'wee-events';

export default new RouteHandler({
    init() {
        $events.on(':back', 'click', () => {
            window.history.back();
        });
    },
});
